import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import EntryContributionCard from "visual-components/analytics/campaign/entry-contribution-card";

class EntryContribution extends Component {
  render() {
    const { data, isHost, filterWebbula, started } = this.props;

    return (
      <EntryContributionCard
        data={data}
        isHost={isHost}
        filterWebbula={filterWebbula}
        started={started}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.analyticsCampaign.campaignEntryContributionStatsByPartner,
  isHost: state.analyticsCampaign.isHost,
  filterWebbula: state.analyticsCampaign.filterWebbula,
});

export default connect(mapStateToProps)(EntryContribution);
